import { createContext } from 'react';
export const MerchantDetailsContext = createContext();
